export default __webpack_public_path__ + "static/media/hero_img2.75a27420.jpg";